import React, { useEffect, useState } from "react";
import PreviewMeetingCard from "./PreviewMeetingCard";
import PreviewMeetingUsersCard from "./PreviewMeetingUsersCard";
import { MEETING_USER, REVIEWS, SUGGESTION } from "app/utils/constants/customConstant";
import { getObjectListByPropertyApi } from "api/general";
import { Box, CircularProgress } from "@mui/material";
import LoadingPopUp from "../LoadingPopup";
import PreviewSuggestionListCard from "./PreviewSuggestionListCard";

function PreviewMeetingDetailCard({ meeting }) {
    const [meetingUsers, setMeetingUsers] = useState([]);
    const [loading, setLoading] = useState();
    const [suggestionList, setSuggestionList] = useState([]);

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            let musers = await getObjectListByPropertyApi(MEETING_USER, "meetingId", meeting.id);
            setMeetingUsers(musers.data);


            const suggestionListResponse = await getObjectListByPropertyApi(SUGGESTION, "meetingId", meeting.id);
            setSuggestionList(suggestionListResponse.data);




            setLoading(false);
        }
        getAPI();
    }, [meeting])

    return (
        <Box>
            <LoadingPopUp open={loading} />
            {!loading && (
                <>

                    <PreviewMeetingCard meeting={meeting} meetingUsers={meetingUsers} />

                    {/* {reviewsOfTheMeeting.length > 0 && (
                        <>
                            <Box sx={{ marginY: 1 }} />
                            <PreviewSuggestionListCard mainData={reviewsOfTheMeeting} meetingUsers={meetingUsers} type="review" />
                        </>
                    )} */}

                    {suggestionList.length > 0 && (
                        <>
                            <Box sx={{ marginY: 1 }} />
                            <PreviewSuggestionListCard mainData={suggestionList} meetingUsers={meetingUsers} />
                        </>
                    )}




                    <Box sx={{ marginY: 1 }} />

                    <PreviewMeetingUsersCard meeting={meeting} meetingUsers={meetingUsers} />

                </>
            )}
        </Box>
    );
}

export default PreviewMeetingDetailCard;
